// extracted by mini-css-extract-plugin
export var box = "_86-1";
export var checked = "_86-2";
export var descriptionSpacer = "_86-9";
export var disabled = "_86-3";
export var icon = "_86-6";
export var input = "_86-0";
export var labelSpacer = "_86-8";
export var medium = "_86-5";
export var small = "_86-4";
export var text = "_86-7";